import { useVerticalScroll } from "@/domains/react/useVerticalScroll";
import styled from "@emotion/styled";
import { ReactNode } from "react";

interface FadeVerticalScrollProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const FadeVerticalScroll = ({ children, className }: FadeVerticalScrollProps) => {
  const { scrollContainerRef, scrollState, handleScroll } = useVerticalScroll();
  return (
    <Wrapper>
      <ScrollableSection ref={scrollContainerRef} onScroll={handleScroll} className={className}>
        {children}
      </ScrollableSection>
      {scrollState.bottomVisible && <FadeBottom />}
      {scrollState.topVisible && <FadeTop />}
    </Wrapper>
  );
};

const Wrapper = styled.div({
  position: "relative",
  height: "100%",
  width: "100%",
});

const ScrollableSection = styled.div({
  overflowY: "auto",
  scrollbarWidth: "none",
  width: "100%",
  height: "100%",

  "::-webkit-scrollbar": {
    display: "none",
  },
});

const FadeBottom = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 28px;
  width: 100%;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.surface.pane}00 0%,
    ${({ theme }) => theme.colors.surface.pane}da 85.42%,
    ${({ theme }) => theme.colors.surface.pane} 100%
  );
  user-select: none;
  pointer-events: none;
`;

const FadeTop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 28px;
  width: 100%;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.surface.pane}00 0%,
    ${({ theme }) => theme.colors.surface.pane}da 85.42%,
    ${({ theme }) => theme.colors.surface.pane} 100%
  );
  transform: rotate(180deg);
  user-select: none;
  pointer-events: none;
`;
